export default __webpack_public_path__ + "static/media/amazon.88352594.svg";